export const openLinkInNewTab = (url: string): void => {
   window.open(url, '_blank', 'noopener, noreferrer')
}

export const openLinkInSameTab = (url: string): void => {
   window.open(url, '_self')
}
